<script setup>  
  import { ref, onMounted, getCurrentInstance } from 'vue';
  import { usePageLoadingStore } from '../../../../../stores/pageLoading';
  import { useRoute, useRouter, RouterLink } from 'vue-router';
  import adminJobfairStateService from '../../../services/jobfair/adminJobfairStateService';
  import JobFairResumeDetailModal from '../../../../user/components/modal/jobFair/JobFairResumeDetailModal.vue';

  const route = useRoute();
  const router = useRouter();
  const loadingStore = usePageLoadingStore();
  const { $gbNameKR, $toast, $number, $pageListBoardNo, $yyyymmddHHmmss } = getCurrentInstance().appContext.config.globalProperties;

  const currentPage = ref(1);
  const pageSize = ref(10);
  const totalPages = ref(1);
  const totalCount = ref(0);
  const list = ref([]);

  const resumeModal = ref(null);

  const pageSizeGroup = ref([
      { label:'10개씩 보기', value: '10' },
      { label:'30개씩 보기', value: '30' },
      { label:'50개씩 보기', value: '50' },
      { label:'100개씩 보기', value: '100' },
  ]);
  
  // 페이지 선택
  const onSelectPage = (pageNo) => {
      currentPage.value = pageNo;
      retrieveList();
  }

  // 검색조건 - 페이지 사이즈 변경. 10,30,50,100
  const onSelectPageSize = (option) => {
      pageSize.value = option.value;
      currentPage.value = 1;
      retrieveList();
  }

  const retrieveList = () => {
    const paramObj = {
      pageNumber: currentPage.value,
      size: pageSize.value,
      corpId: route.params?.id || '',
    };

    loadingStore.loading = true;
    adminJobfairStateService.retrieveInterestHallEntryListPagingByCorpId(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        if (res.data.code.toLowerCase() === "success") {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        }
      })
      .catch((res) => {
        loadingStore.loading = false;
        $toast("error", res);
      });
  }

  const onClickResume = async (resumeId) => {
    await resumeModal.value.show({
      resumeId,
    });
  }

  const openDetailInNewTab = (linkName, id = {}) => {
    const url = router.resolve({
      name: linkName,
      params: { id },
    }).href;

    window.open(url, '_blank');
  }

  onMounted(() => {
    retrieveList();
  })
</script>
<template>
  <div class="list-top">
    <p>전체 <span>{{ $number(totalCount)}}</span>개</p>
    <div>
      <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize" />
    </div>
  </div>
  <div class="table-form">
    <table class="horizontal">
      <tr>
        <th>NO</th>
        <th>회원코드</th>
        <th>이름</th>
        <th>아이디</th>
        <th>이력서 제목</th>
        <th>관심 카테고리</th>
        <th>전공계열(주전공)</th>
        <th>등록일</th>
        <th>등록 마스터</th>
      </tr>
      <tr v-for="talent in list" :key="talent.boardNo">
        <td>{{ talent.boardNo }}</td>
        <td>{{ talent.userId }}</td>
        <td class="clickable blue">
          <span @click="openDetailInNewTab('MemberDetail', talent.userId)">{{ talent.userName }}</span>
        </td>
        <td>{{ talent.userLoginId }}</td>
        <td class="text-overflow long-overflow">
          <span class="file" v-if="talent.fileYn === 'Y'" v-for="resumeAttaches in talent.resumeAttaches" :key="resumeAttaches.attachSeq || resumeAttaches.fileName" @click="$downloadForPrivate({fileName:resumeAttaches.fileName, fileDir: resumeAttaches.fileDir })">
            {{ resumeAttaches.fileName }}
          </span>
          <span class="clickable blue" v-else @click="onClickResume(talent.resumeId)">
            {{ talent.title }}
          </span>
        </td>
        <td>{{ talent.interests }}</td>
        <td>{{ $gbNameKR('MAJOR_GB', talent.majorGb) }}</td>
        <td>{{ $yyyymmddHHmmss(talent.createDate) }}</td>
        <td class="clickable blue">
          <span  @click="openDetailInNewTab('MemberDetail', talent.masterId)">{{ talent.masterName }}</span>
        </td>
      </tr>
    </table>
    <div class="result-none" v-if="list.length === 0">
      등록된 관심인재가 없습니다.
    </div>
  </div>
  <Paginate
    v-if="list.length > 0"
    v-model="currentPage"
    :page-count="totalPages"
    :click-handler="onSelectPage"
  />
  <JobFairResumeDetailModal ref="resumeModal" /> <!-- 이력서 보기-->
</template>

<style scoped>
</style>
